import { ReactComponent as InstaLogo } from "../../assets/icons/icon_instagram.svg";
import { ReactComponent as WhatsAppLogo } from "../../assets/icons/icon_whatsapp.svg";
import { ReactComponent as TelegLogo } from "../../assets/icons/icon_telegram.svg";
import { ReactComponent as AppStoreLogo } from "../../assets/icons/app-store_icon.svg";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import { isIOS } from "react-device-detect";
import useIsMobile from "../../hooks/useIsMobile";

export const Footer = () => {
  const isMobile = useIsMobile();
  return (
    <footer className={styles.footer} id="contacts">
      <>
        {isMobile ? (
          <div className={styles["footer-left-container"]}>
            <div>
                <Link className={styles.logoLink} to={`/home`}>
                    <h1 className={styles.logo}>zametna</h1>
                </Link>
                <div className={styles.footerSection}>
                <h1>О нас</h1>
                <p>Площадка для онлайн шоппинга</p>
                <p>Особый отбор бренов и коллекций</p>
                <p>Быстрая доставка с примеркой</p>
                {/*{isIOS && (*/}
                {/*  <a href="https://apps.apple.com/kz/app/zametna/id6742846927">*/}
                {/*    Пробуйте систему видеошоппинга, вдохновляйтесь образами в*/}
                {/*    приложении (beta)*/}
                {/*  </a>*/}
                {/*)}*/}
              </div>
              <div className={styles.footerSection}>
                <h1>Покупателям</h1>
                <a
                  href="https://t.me/zametna_com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Служба поддержки
                </a>
                <Link to="/order-contract">Публичная оферта</Link>
                <Link to="/privacy-policy">Политика обработки персональных данных</Link>
              </div>
            </div>
            <div className={styles.footerSection}>
              <h1>Партнерам</h1>
              <a href="https://zametna.com/admin/register">Cтать партнером</a>
            </div>
            <div className={styles.footerSection}>
              <h1>Контакты</h1>
              <p>+7 (929) 503-29-17</p>
              <p>info@zametna.com</p>
              <div className={styles.socialNetworks}>
                <a href="https://www.instagram.com/zametna_">
                  <InstaLogo />
                </a>
                <a href="https://wa.me/+79295032917">
                  <WhatsAppLogo />
                </a>
                <a href="https://t.me/zametna_com">
                  <TelegLogo />
                </a>
              </div>
            </div>
            {isIOS && (
              <div className={styles.footerSection}>
                <a
                  href="https://apps.apple.com/kz/app/zametna/id6742846927"
                  target="_blank"
                  rel="noreferrer"
                >
                  <AppStoreLogo />
                </a>
              </div>
            )}
          </div>
        ) : (
          <>
            <div className={styles["footer-left-container"]}>
              <div className={styles.footerBoxLeft}>
                <div className={styles.footerSection}>
                  <h1>О нас</h1>
                  <p>zametna.com - площадка для онлайн шоппинга</p>
                  <p>Особый отбор бренов и коллекций</p>
                  <p>Быстрая доставка с примеркой</p>
                  {/*{isIOS && (*/}
                  {/*  <p>*/}
                  {/*    Пробуйте систему видеошоппинга, вдохновляйтесь образами в*/}
                  {/*    приложении (beta)*/}
                  {/*  </p>*/}
                  {/*)}*/}
                </div>
                <div className={styles.footerSection}>
                  <h1>Покупателям</h1>
                  <a
                    href="https://t.me/zametna_com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Служба поддержки
                  </a>
                  <Link to="/order-contract">Публичная оферта</Link>
                  <Link to="/privacy-policy">Политика обработки данных</Link>
                </div>
              
              </div>
            </div>
            <div className={styles["footer-right-container"]}>
              <div className={styles.footerBoxRight}>
                <div className={styles.footerSection}>
                  <h1>Партнерам</h1>
                  <a href="https://zametna.com/landing/p">
                    О нас
                  </a>
                  <a href="https://zametna.com/admin/register">
                    Стать партнером
                  </a>
                </div>
                <div className={styles.footerSection}>
                  <h1>Контакты</h1>
                  <p>+7 (925) 167-36-86</p>
                  <p>info@zametna.com</p>
                  <div className={styles.socialNetworks}>
                    <a href="https://www.instagram.com/zametna_">
                      <InstaLogo />
                    </a>
                    <a href="https://wa.me/+79295032917">
                      <WhatsAppLogo />
                    </a>
                    <a href="https://t.me/zametna_com">
                      <TelegLogo />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    </footer>
  );
};
